<div class="ef-page">

  <div class="ef-header">
    <div class="ef-header__icon"><mat-icon>show_chart</mat-icon></div>
    <div>
      <h1 class="ef-header__title">{{ uid ? 'Editar ingreso financiero' : 'Nuevo ingreso financiero' }}</h1>
      <p class="ef-header__sub">{{ uid ? 'Modifica los datos del ingreso financiero' : 'Registra intereses, dividendos u otros ingresos financieros' }}</p>
    </div>

    <div class="pf-header-actions">
      <button mat-stroked-button type="button" class="pf-btn-cancel" (click)="onCancel()" [disabled]="isSaving">
        <mat-icon>arrow_back</mat-icon> Volver
      </button>
      <button mat-flat-button type="button" class="ef-btn-save" (click)="onSave()" [disabled]="isSaving || isLoading">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>
  </div>

  <div class="ef-body" *ngIf="!isLoading">
    <form [formGroup]="form" class="fif-form">

      <div class="pf-side-by-side">
        <mat-card appearance="outlined" class="tf-card">
          <mat-card-content>
            <div class="tf-section-header">
              <h6 class="tf-section-title">Datos del ingreso</h6>
            </div>

            <app-autocomplete [control]="form.get('concept')" [config]="{
                label: 'Descripción / Concepto',
                placeholder: 'Buscar o escribir concepto...',
                options: concepts,
                allowCustomValues: true,
                customValueLabel: 'Usar este concepto'
              }">
            </app-autocomplete>

            <app-date [control]="form.get('date')" [config]="{ label: 'Fecha' }"></app-date>
            <p class="fif-error" *ngIf="form.get('date').hasError('fiscalYear') && form.get('date').touched">
              La fecha debe pertenecer al ejercicio {{ fiscalYear }}.
            </p>

            <app-autocomplete *ngIf="isProjectEnable" [control]="form.get('projectUid')" [config]="{
                label: 'Proyecto',
                placeholder: 'Seleccionar proyecto...',
                options: projects
              }">
            </app-autocomplete>
          </mat-card-content>
        </mat-card>

        <mat-card appearance="outlined" class="tf-card">
          <mat-card-content>
            <div class="tf-section-header">
              <h6 class="tf-section-title">Importes y contabilidad</h6>
            </div>

            <div class="pf-grid-2">
              <app-field [control]="form.get('amountWithoutTax')" [config]="{ label: 'Importe bruto (€)', type: 'number' }"></app-field>
              <app-field [control]="form.get('commissions')" [config]="{ label: 'Comisiones (€)', type: 'number' }"></app-field>
            </div>

            <div class="fif-retention">
              <div class="fif-retention__label">
                <span>Retención (calculada)</span>
                <small>{{ irpfRate ? irpfRate + ' % sobre el importe bruto' : 'Indica el importe bruto' }}</small>
              </div>
              <div class="fif-retention__value">{{ retention | number:'1.2-2':'es-ES' }} €</div>
            </div>

            <app-autocomplete [control]="form.get('entranceAccount')" [config]="{
                label: 'Cuenta contable',
                placeholder: 'Buscar cuenta...',
                options: accounts
              }">
            </app-autocomplete>

            <app-autocomplete [control]="form.get('bankAccountUid')" [config]="{
                label: 'Cuenta bancaria',
                placeholder: 'Seleccionar cuenta...',
                options: bankAccounts, autoSelectSingle: true
              }">
            </app-autocomplete>

            <p class="fif-hint" *ngIf="!bankAccounts.length">
              <mat-icon>info</mat-icon>
              <span>No tienes cuentas bancarias. Puedes crearlas desde el menú Mi Cuenta.</span>
            </p>
          </mat-card-content>
        </mat-card>
      </div>

    </form>
  </div>

  <div class="ef-loading" *ngIf="isLoading">
    <app-loading-state [message]="uid ? 'Cargando ingreso financiero…' : 'Preparando formulario…'"></app-loading-state>
  </div>

</div>
